<template>
  <div
    class="is-teacher flex min-h-screen w-full flex-col justify-between bg-white max-md:pb-navbar-height"
    :class="{
      'pt-navbar-height': auth.user && !auth.user.is_student,
    }"
  >
    <Tab />

    <TeacherNavigationDesktop v-if="auth.user && !auth.user.is_student" />
    <PublicNavigation v-else />

    <div class="pt-18" />

    <slot />

    <AppFooter class="max-md:hidden" />

    
  </div>
</template>

<script setup lang="ts">
const auth = useAuthStore()
const icon = useFavicon()

icon.value = '/favicon-teacher.svg'
</script>
